import styled from 'styled-components';
import { mediaBelow, pxToRem } from '../../assets/styles/helper';
import { uFlexColumn } from '../../assets/styles/utility';
import { variables } from '../../assets/styles/variables';

const TradingFilter = styled.div`
  ${uFlexColumn};
  width: ${pxToRem(278)};
  flex-shrink: 0;
  margin-right: ${pxToRem(52)};
  position: relative;

  ${mediaBelow(variables.breakpoints.bpXl)} {
    display: none;
  }
`;

export default TradingFilter;
